import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionFilter", "startDate", "endDate"]

  connect() {
    // Set the user ID from the component's data attribute
    this.userId = this.element.dataset.userId
  }

  filterChanged() {
    this.applyFilters()
  }

  setDateRange(event) {
    const range = event.currentTarget.dataset.range
    const today = new Date()
    let startDate, endDate

    switch(range) {
      case 'today':
        startDate = endDate = today
        break
      case '7_days':
        startDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
        endDate = today
        break
      case '30_days':
        startDate = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000)
        endDate = today
        break
    }

    if (startDate && this.hasStartDateTarget) {
      this.startDateTarget.value = this.formatDate(startDate)
    }
    if (endDate && this.hasEndDateTarget) {
      this.endDateTarget.value = this.formatDate(endDate)
    }

    this.applyFilters()
  }

  clearFilters() {
    if (this.hasActionFilterTarget) {
      this.actionFilterTarget.value = ''
    }
    if (this.hasStartDateTarget) {
      this.startDateTarget.value = ''
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.value = ''
    }

    this.applyFilters()
  }

  applyFilters() {
    const params = new URLSearchParams()
    
    if (this.hasActionFilterTarget && this.actionFilterTarget.value) {
      params.append('activity_filter[action]', this.actionFilterTarget.value)
    }
    if (this.hasStartDateTarget && this.startDateTarget.value) {
      params.append('activity_filter[start_date]', this.startDateTarget.value)
    }
    if (this.hasEndDateTarget && this.endDateTarget.value) {
      params.append('activity_filter[end_date]', this.endDateTarget.value)
    }

    // Add Turbo Stream accept header for partial updates
    const headers = {
      'Accept': 'text/vnd.turbo-stream.html',
      'X-Requested-With': 'XMLHttpRequest'
    }

    // Reload the timeline with filters
    const url = `${window.location.pathname}?${params.toString()}`
    
    fetch(url, { headers })
      .then(response => response.text())
      .then(html => {
        // If we get a Turbo Stream response, it will handle the update
        // Otherwise, we need to manually update the content
        if (!html.includes('turbo-stream')) {
          // Find the activity timeline container and update it
          const container = this.element.closest('.activity-timeline-container')
          if (container) {
            container.innerHTML = html
          }
        }
      })
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}